import axios from "axios";
import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";



const VideoPanel = () => {

    const [search, setSearch] = useState("");
    const [wishlist, setWishlist] = useState([]);
    const [filteredWishlist, setFilterWishlist] = useState([]);


    const getWishlist = async () => {
        try {
            const response = await axios.get('https://igapi.heuristticminds.com/api/VideoList/Get-ArtistVideoList')
            setWishlist(response.data);
            setFilterWishlist(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    const columns = [
        {
            name: "ID",
            selector: row => row.id,
            sortable: true,
        },
        {
            name: "User",
            selector: row => row.artistName,
            sortable: true,
        },
        {
            name: "Video",
           // cell: (row) => <div width="400">{row.videoURL}</div>,
            cell: (row) => <div width="400"><iframe width="200" src={row.videoURL} frameborder="0" allow="accelerometer;rel=0?version=3&amp;autoplay=1&amp;&amp;controls=0&amp;&amp;showinfo=0&amp;loop=1; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div>,
        },
        {
            name: "Status",
            selector: row => row.videoStatus,
            sortable: true,
        },

        {
            name: "Action",
            cell: (row) => <><button className="btn btn-light me-2" onClick={() => alert(row.id)}><i className="bi bi-pencil-square"></i></button>
                <button className="btn btn-light" onClick={() => alert(row.id)}><i className="bi bi-trash3-fill"></i></button></>
        },
    ];


    useEffect(() => {
        getWishlist()
    }, []);

    useEffect(() => {
        const result = wishlist.filter((wishl) => {
            return wishl.artistName.toLowerCase().match(search.toLowerCase());
        });

        setFilterWishlist(result);
    }, [search]);



    return (
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='Videos Panel' icon='bi bi-film' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Artist videos</div>
                                        <div className="card-body">

                                            <DataTable
                                                columns={columns}
                                                data={filteredWishlist}
                                                pagination
                                                fixedHeader
                                                fixedHeaderScrollHeight="380px"
                                                subHeader
                                                subHeaderComponent={
                                                    <input type="text"
                                                        placeholder="search keyword"
                                                        value={search}
                                                        onChange={(e) => { setSearch(e.target.value) }}
                                                    />
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default VideoPanel;